import "./Header.css";

const header = () => {
    return <span onClick={()=>window.scroll(0,0)} className="header">🎥 CINEMA POP 🎭</span>
}

export default header
